import get from 'lodash/get';
import { createNamespacedHelpers } from 'vuex';

import ConciergeDefs from '@/store/concierge/concierge.d';
import LayoutDefs from '@/store/layout/layout.d';

import LoadingDots from '@/components/loading_dot/LoadingDot.vue';
import SettingFinancialPaypal from '@/components/setting_financial_paypal/SettingFinancialPaypal.vue';
import SettingFinancialBank from '@/components/setting_financial_bank/SettingFinancialBank.vue';

import ModalChangePassword from '@/components/modal_change_password/ModalChangePassword.vue';

const {
  mapActions: mapLayoutActions,
  mapState: mapLayoutState
} = createNamespacedHelpers('Layout');

const { mapActions: mapConciergeActions } = createNamespacedHelpers(
  'Concierge'
);

export default {
  name: 'ConciergeAccount',
  components: {
    LoadingDots,
    SettingFinancialPaypal,
    SettingFinancialBank,
    ModalChangePassword
  },
  mounted: function() {
    this.setConciergePayoutForm();
  },
  props: {
    currentConcierge: Object
  },
  data: () => ({
    selectedPayment: 'paypal',
    form: {
      firstName: '',
      lastName: '',
      email: ''
    }
  }),

  computed: {
    ...mapLayoutState({
      modal: state => state.modal
    }),

    getConciergePaypalAccount: function() {
      const { payoutMethod } = this.currentConcierge;
      const paypalEmail = get(payoutMethod, 'email', null);
      return { paypalEmail };
    },

    getConciergeBankAccount: function() {
      const { payoutMethod } = this.currentConcierge;
      const bankAccount = get(payoutMethod, 'bankAccount', {});
      return {
        accountName: get(bankAccount, 'accountName', null),
        accountNumber: get(bankAccount, 'accountNumber', null),
        accountType: get(bankAccount, 'accountType', null),
        bankName: get(bankAccount, 'bankName', null),
        branchName: get(bankAccount, 'branchName', null)
      };
    }
  },

  watch: {
    currentConcierge: {
      handler: 'loadForm',
      immediate: true
    }
  },

  methods: {
    ...mapConciergeActions({
      updateConcierge: ConciergeDefs.actions.updateConcierge,
      conciergeStore_updateConciergePayout:
        ConciergeDefs.actions.updateConciergePayout
    }),

    ...mapLayoutActions({
      layoutStore_openModal: LayoutDefs.actions.openModal
    }),

    openChangePasswordModal: function() {
      this.layoutStore_openModal({ module: 'changePassword' });
    },

    loadForm: function() {
      const { currentConcierge } = this;
      this.form.firstName = currentConcierge.firstName;
      this.form.lastName = currentConcierge.lastName;
      this.form.email = currentConcierge.email;
    },

    handleOnInfoSaveClick: async function() {
      return this.displayToast(false);

      // TODO: Create a store for updating other concierge
      // this.$loading.start('settings.saveAccount');

      // try {
      //   const payload = pick(this.form, ['firstName', 'lastName']);
      //   await this.updateConcierge(payload);
      //   this.$toast.open({
      //     message: 'Account changes has been saved. ',
      //     position: 'top-right'
      //   });
      // } catch (error) {
      //   // TODO: Handle error correctly
      //   this.$toast.open({
      //     type: 'error',
      //     message: 'Something happens, profile save was failed. ',
      //     position: 'top-right'
      //   });
      // }

      // this.$loading.end('settings.saveAccount');
    },

    // eslint-disable-next-line max-lines-per-function
    // eslint-disable-next-line complexity
    handleOnFinancialSaveClick: async function() {
      return this.displayToast(false);

      // TODO: Create a store for updating other concierge
      // if (!this.$loading.is('settings.saveFinancial')) {
      //   this.$loading.start('settings.saveFinancial');

      //   try {
      //     if (this.selectedPayment === 'paypal') {
      //       const { paypal } = this.form;

      //       if (paypal.paypalEmail !== paypal.confirmPaypalEmail) {
      //         this.displayToast(false);
      //       } else {
      //         paypal.type = 'paypal';

      //         await this.conciergeStore_updateConciergePayout(paypal);
      //         this.displayToast(true);
      //       }
      //     } else if (this.selectedPayment === 'bank') {
      //       const { bankAccount } = this.form;
      //       bankAccount.type = 'bank';

      //       await this.conciergeStore_updateConciergePayout(bankAccount);
      //       this.displayToast(true);
      //     }
      //   } catch (error) {
      //     // TODO: Handle error correctly
      //     this.displayToast(false);
      //   }

      //   this.$loading.end('settings.saveFinancial');
      // }
    },

    setConciergePayoutForm: function() {
      if (this.selectedPayment === 'paypal') {
        this.form.paypal = this.getConciergePaypalAccount;
      } else if (this.selectedPayment === 'bank') {
        this.form.bankAccount = this.getConciergeBankAccount;
      }
    },

    handleOnFinancialInfoChange: function(payload) {
      if (this.selectedPayment === 'paypal') {
        this.form.paypal = payload;
      } else if (this.selectedPayment === 'bank') {
        this.form.bankAccount = payload;
      }
    },

    displayToast: function(success) {
      if (success) {
        this.$toast.open({
          message: 'Financial Info changes has been saved. ',
          position: 'top-right'
        });
      } else {
        this.$toast.open({
          type: 'error',
          message: 'Something happens, profile save was failed. ',
          position: 'top-right'
        });
      }
    }
  }
};
